<template>
  <panel
    class="case-custom-menus"
    color="#3fabd9"
    title="Custom Menus"
    scroll-mode="content"
    aria-label="Section Header"
    data-testid="section-header"
  >
    <span class="md-subheading" aria-label="Section Subheader" data-testid="section-subheader">Name and create custom buttons that appear at the bottom of the main menus within the simulation.</span>
    <div class="tabs-container" data-testid="custom-menus-container">
      <vrp-tabs
        :tabs="tabs"
        :active-tab-key="state.activeTabKey"
        :resizeable="false"
        @change-tab="setTabKey"
      >
        <template v-slot:header-prefix />
        <template #item="{ key }">
          <custom-menu
            :custom-menu="getCustomMenu(key)"
            :readonly="readonly"
            @update="value => emitUpdate(key, value)"
          />
        </template>
      </vrp-tabs>
    </div>
  </panel>
</template>

<script>
import { cloneDeep } from 'lodash';
import Panel from '../common/Panel';
import VrpTabs from '../common/VrpTabs/VrpTabs';
import CustomMenu from './CustomMenu';

export default {
  name: 'case-custom-menus',
  components: {
    Panel,
    VrpTabs,
    CustomMenu,
  },
  props: {
    caseConf: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tabs: [
        { key: 'ASSESS', label: 'ASSESS' },
        { key: 'MONITOR', label: 'MONITOR' },
        { key: 'TREAT', label: 'TREAT' },
      ],
      defaultMenu: {
        buttonLabel: { en: '' },
        iconKey: 'NESTED'
      },
      state: {
        activeTabKey: 'ASSESS'
      }
    };
  },
  methods: {
    getCustomMenu(category) {
      const { customMenus } = this.caseConf;
      if (customMenus) {
        const menu = customMenus.find(menu => menu.category === category)
        if (menu) {
          return menu;
        }
      }
      return {
        ...this.defaultMenu,
        category
      }
    },
    setTabKey(key) {
      this.state.activeTabKey = key;
    },
    emitUpdate(category, newValue) {
      const updatedMenus = cloneDeep(this.caseConf.customMenus || []);
      const index = updatedMenus.findIndex(menu => menu.category === category);
      if (index >= 0) {
        updatedMenus[index] = newValue;
      } else {
        updatedMenus.push(newValue);
      }
      this.$emit('update', { customMenus: updatedMenus });
    }
  }
}
</script>

<style scoped>
.tabs-container {
  display: flex;
  padding-top: 20px;
  height: 100%;
}
.vrp-tabs {
  flex: 1;
}
</style>